import { getField, updateField } from 'vuex-map-fields';
import { types } from './mutation-types';

/**
 * VueX pattern
 * View -> Actions -> State -> View ...
 *
 * State -> VueComponent -> Action -> --Commit-- Mutations(change state) -> State
 *
 * Projects Vuex modules structure base on : https://vuex.vuejs.org/guide/structure.html
 */
export const confection = {
  namespaced: true,
  state: {
    isConfectionEnabled: localStorage.getItem('confection'),
    selectedExclusiveItem: null,
    selectedConfectionItems: {},
    shouldShowIncentiveModal: true,
    grantingCompanyName: '',
    grantingReason: '',
    grantingReasonEn: '',
    grantingReasonUa: '',
    envelopeLayout: '',
    splitCriteria: '',
    hasIndividualPersonalization: false,
    personalizationText: '',
    personalizationComment: '',
    data: [],
  },
  /*
  * yourGetter(state) { return state.yourState }
  * */
  getters: {
    getField,
  },
  /**
   * Mutations update the state
   * Mutations MUST BE SYNC
   * */
  actions: {
    /*
    * handleSetConfectionEnabled
    * @param {context} - context: { commit )
    * @param {isConfectionEnabled} - tyoe: Boolean - value of confection availability
    * */
    handleSetConfectionEnabled({ commit }, isConfectionEnabled) {
      if (typeof isConfectionEnabled !== 'boolean') {
        // eslint-disable-next-line no-console
        console.warn(`store.confection.handleSetConfectionEnabled -> passed props: handleSetConfectionEnabled="${isConfectionEnabled}" is NOT Boolean. This make sure u pass proper value `);
      } else {
        commit(types.SET_CONFECTION_ENABLED, isConfectionEnabled);
      }
    },
    handleConfectionItemSelection({ commit }, { selectedItem, isSelected }) {
      commit(types.HANDLE_CONFECTION_ITEM_SELECTION, { selectedItem, isSelected });
    },
    setSelectedExclusiveItem({ commit }, selectedItem) {
      commit(types.SET_SELECTED_CONFECTION_ITEM, selectedItem);
    },
    setShouldShowIncentiveModal({ commit }, shouldShow) {
      commit(types.SET_SHOULD_SHOW_INCENTIVE_MODAL, shouldShow);
    },
    resetPersonalization({ commit }, hasIndividualPersonalization) {
      commit(types.RESET_PERSONALIZATION, hasIndividualPersonalization);
    },
    setConfectionData({ commit }, data) {
      commit(types.SET_DATA, data);
    },
    resetConfection({ commit }) {
      commit(types.RESET);
    },

  },
  mutations: {
    updateField,
    /*
    * @param {state} - reffer to state
    * @param {payload} - is passed from action as param
    * */
    [types.SET_CONFECTION_ENABLED](state, isConfectionEnabled) {
      state.isConfectionEnabled = isConfectionEnabled;
    },
    [types.HANDLE_CONFECTION_ITEM_SELECTION](state, { selectedItem, isSelected }) {
      state.selectedConfectionItems = {
        ...state.selectedConfectionItems,
        [selectedItem]: isSelected,
      };
    },
    [types.SET_SELECTED_CONFECTION_ITEM](state, selectedItem) {
      state.selectedExclusiveItem = selectedItem;
    },
    [types.SET_SHOULD_SHOW_INCENTIVE_MODAL](state, shouldShow) {
      state.shouldShowIncentiveModal = shouldShow;
    },
    [types.RESET_PERSONALIZATION](state, hasIndividualPersonalization) {
      state.hasIndividualPersonalization = !!hasIndividualPersonalization;
      state.personalizationText = '';
      state.personalizationComment = '';
    },
    [types.SET_DATA](state, data) {
      state.data = Array.isArray(data) ? data : [];
    },
    [types.RESET](state) {
      state.isConfectionEnabled = false;
      state.selectedExclusiveItem = null;
      state.selectedConfectionItems = {};
      state.shouldShowIncentiveModal = {};
      state.grantingCompanyName = '';
      state.grantingReason = '';
      state.grantingReasonEn = '';
      state.grantingReasonUa = '';
      state.envelopeLayout = '';
      state.splitCriteria = '';
      state.hasIndividualPersonalization = false;
      state.personalizationText = '';
      state.personalizationComment = '';
      state.data = [];
    },
  },
  /*
  * Actions commit mutations
  * This is place to get data from API
  * */

};
